module.exports = "/_next/static/images/QuestThumbnail-147d1ab69cc6eeb0c05c2882e477512a.webp";